module.exports = __webpack_public_path__ + "bin/b2ddd05c41e0c169b6566976fa380a68.png";